module.exports = __webpack_public_path__ + "media/images/iconTrend--down-e0abb493c67d1d055fff0662c7f6556c.png";